
export type _SalaryComponent = 'base' | 'allowance' | 'bonus';

export interface ISalaryComponent {
    id: number,
    type: _SalaryComponent,    

    code: string,
    name: string,
    description: string,
    isActive: boolean,

  }
  
  export const defaultSalaryComponent : ISalaryComponent = {
    id: 0,
    type: 'base',  

    code: '',
    name: '',
    description: '',
    isActive: true,    
  }

  

  export interface ISalaryComponentSearch {
 
    name: string,
    description: string
  }